<div class="modal-signup modal-content border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add New Service

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body padding-top-0px padding-bottom-0px">


            <form class="form" novalidate="" (ngSubmit)="AddService()" #fm2="ngForm">

              <div class="card card-height-417px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">

                        <div class="card-body card-body-general padding-top-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Name </label>
                                </div>
                                <div class="col-md-8">

                                  <!--<input type="text" class="form-control" placeholder="Service Name"
                                         id="CurrentSaveNewServiceRequest.ServiceName"
                                         [(ngModel)]="CurrentSaveNewServiceRequest.ServiceName"
                                         name="CurrentSaveNewServiceRequest.ServiceName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="140" minlength="1">-->
                                  <textarea class="form-control3 size-2 width-inherit"
                                            rows="2" placeholder="Service Name"
                                            name="CurrentSaveNewServiceRequest.ServiceName"
                                            [(ngModel)]="CurrentSaveNewServiceRequest.ServiceName"
                                            maxlength="140" minlength="1"></textarea>
                                </div>

                              </div>

                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Department Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CustomDataByRequestType RequestedType="Departments List" class="form-group" FacilityCode={{FacilityCode}}
                                                           [(ngModel)]="CurrentSaveNewServiceRequest.DepartmentCode" (keyChange)="Department($event)"
                                                           name="CurrentSaveNewServiceRequest.DepartmentCode" #DepartmentsList="ngModel">
                                  </CustomDataByRequestType>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Category Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CustomDataByRequestType RequestedType="Service Category list" class="form-group" FacilityCode={{FacilityCode}}
                                                           [(ngModel)]="CurrentSaveNewServiceRequest.ServiceCategoryCode" (keyChange)="ServiceCategory($event)"
                                                           name="CurrentSaveNewServiceRequest.ServiceCategoryCode" #ServiceCategoryCode="ngModel">
                                  </CustomDataByRequestType>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Revenue Category Code</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="REVCT" id="CurrentSaveNewServiceRequest.RevenueCategoryCode"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.RevenueCategoryCode"
                                                 name="CurrentSaveNewServiceRequest.RevenueCategoryCode">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Type</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="GSVCT" id="CurrentSaveNewServiceRequest.ServiceType"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.ServiceType"
                                                 name="CurrentSaveNewServiceRequest.ServiceType">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Service Point</label>
                                </div>
                                <div class="col-md-6">
                                  <CodeTypeValue CodeType="Servi" id="CurrentSaveNewServiceRequest.ServicePoint"
                                                 [(ngModel)]="CurrentSaveNewServiceRequest.ServicePoint"
                                                 name="CurrentSaveNewServiceRequest.ServicePoint">
                                  </CodeTypeValue>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Price </label>
                                </div>
                                <div class="col-md-6">
                                  <input type="text" class="form-control" placeholder="Price"
                                         id="CurrentSaveNewServiceRequest.Price"
                                         [(ngModel)]="CurrentSaveNewServiceRequest.Price"
                                         name="CurrentSaveNewServiceRequest.Price" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         maxlength="30" required #Price="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Price.valid && (Price.dirty || Price.touched) && Price.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!Price.valid && Price.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>


                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName" class="margin-bottom-0px margin-top-5px">Is Price Editable</label>
                                </div>

                                <div class="col-md-3">
                                  <input type="checkbox" [(ngModel)]="CurrentSaveNewServiceRequest.IsPriceEditable"
                                         class="width-15px" name="CurrentSaveNewServiceRequest.IsPriceEditable">
                                </div>
                              </div>


                            </div>
                          </div>-->

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <div class="card-footer">
                  <button type="submit" class="btn actions-btn-prime float-right font-size-13px" [disabled]="!fm2.form.valid">Save</button>
                </div>
              </div>

            </form>      


        </div>
      </div>
    </div>
  </div>

